import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefDebriefingStatus } from './interface/IRefDebriefingStatus';

@Entity('ref_debriefing_status')
export class RefDebriefingStatus extends BaseEntity implements IRefDebriefingStatus {
    apiMapping = {
        id: 'id',
        name: 'name',
    };

    @PrimaryGeneratedColumn()
    id: number;

    @Column()
    name: string;

    @Column({ nullable: true })
    isDeleted: boolean;
}
